import { render } from "./footerComponent.vue?vue&type=template&id=c79a7b62&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"

import "./footerComponent.vue?vue&type=style&index=0&id=c79a7b62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79a7b62"]])

export default __exports__